import { useTheme } from "@repo/tokens";
import type { TopicSummary } from "../../../../../types/reviseTypes";
import styles from "./TopicSummaryCard.module.scss";
import { Icon, Text } from "@repo/ui";

export const TopicSummaryCard = ({
  topic,
  cardWidth,
  subjectName: _subjectName,
  onPress,
}: {
  topic?: TopicSummary;
  cardWidth: number;
  subjectName: string;
  onPress?: () => void;
}) => {
  const { theme } = useTheme();
  const dynamicStyles = useDynamicWidgetStyles(topic?.progressPercent ?? 0);
  return (
    <div
      className={styles.container}
      style={{
        width: "100%",
        minWidth: cardWidth,
        maxWidth: "100%",
        boxSizing: "border-box",
      }}
      onClick={onPress}
    >
      <div className={styles.bg}>
        <Icon
          name="topicSummaryBg"
          width={85.5}
          height={57}
          color={theme.colors.subject[_subjectName][90]}
        />
      </div>
      <div className={styles.content}>
        <Text className={styles.sequenceNumber}>
          {String(topic?.practiceCardSequenceNumber ?? 0).padStart(2, "0")}
        </Text>

        <div className={styles.topicAndProgressContainer}>
          <Text className={styles.topicTitle}>{topic?.topicName}</Text>

          <div className={styles.progressBarTextContainer}>
            <div className={styles.progressBar}>
              <div
                className={styles.progressBarFilled}
                style={dynamicStyles.progressBarFillDynamic}
              />
            </div>
            <Text className={styles.cardProgressInText}>{topic?.cardText}</Text>
          </div>
        </div>
      </div>
    </div>
  );
};

export const useDynamicWidgetStyles = (progressPercent: number) => {
  return {
    progressBarFillDynamic: {
      width: `${progressPercent}%`,
    },
  };
};
